import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import LoadingScreen from '../../components/muiLegacy/LoadingScreen/LoadingScreen';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelButtonGrid from '../../components/voxel/Buttons/VoxelButtonGrid';
import VoxelPageContainer from '../../components/voxel/Containers/VoxelPageContainer';
import { usersApiService } from '../../graphql/users/usersApiService';
import LoadingItemSpinner from '../ProjectPage/ProjectAppBar/StatusIndicator/LoadingItem/LoadingItemSpinner';
import { TeamMenuChoices } from '../TeamPage/TeamPage';

export interface StripeCheckoutSuccessProps {
  sessionId?: string;
}

export const StripeCheckoutSuccess: React.FC<StripeCheckoutSuccessProps> = ({ sessionId }) => {
  const { status, query: checkoutQuery } = usersApiService.queries.useGetStripeCheckout(
    {
      stripeCheckoutId: sessionId,
    },
    { pollInterval: 2000 }
  );

  const history = useHistory();
  const subscriptionPage = '/team/' + TeamMenuChoices.Subscription;
  const goToSubscriptionPage = () => history.push(subscriptionPage);

  // Handle complete checkout
  useEffect(() => {
    if (status === 'complete') {
      goToSubscriptionPage();
    }
  }, [status]);

  return (
    <VoxelPageContainer>
      {!checkoutQuery.error && status === 'complete' && (
        <VoxelAlert severity="success" title="Checkout successful">
          Your subscription is now activated
        </VoxelAlert>
      )}
      {!checkoutQuery.error && status === 'open' && (
        <VoxelAlert severity="info" title="Processing checkout">
          <LoadingItemSpinner />
        </VoxelAlert>
      )}
      {!checkoutQuery.error && status === 'expired' && (
        <VoxelAlert severity="warning" title="Checkout expired">
          Your checkout was never completed. Please try again.
        </VoxelAlert>
      )}
      {!!checkoutQuery.error && (
        <VoxelAlert severity="warning" title="Checkout not found">
          Sorry, we could not find your checkout session. Get in touch with us if the problem
          persists.
        </VoxelAlert>
      )}

      <div className="h-8" />

      <VoxelButtonGrid>
        <VoxelButton
          disabled={status === 'open' && !checkoutQuery.error}
          title="Go to subscription page"
          startIcon={<FontAwesomeIcon icon={faHouse} />}
          onClick={goToSubscriptionPage}
        />
      </VoxelButtonGrid>
    </VoxelPageContainer>
  );
};

export default StripeCheckoutSuccess;
